import { NgModule } from '@angular/core';
import { ClaimCustomerComponent } from './claim-customer/claim-customer.component';
import { ClaimPicturesComponent } from './claim-pictures/claim-pictures.component';
import { ClaimRepairFacilityComponent } from './claim-repair-facility/claim-repair-facility.component';
import { ClaimService } from './claim.service';
import { NgxMaskModule } from 'ngx-mask';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '../../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserCache } from "../claims-app/services/user/user.cache";
import { ReportAClaimComponent } from './report-a-claim/report-a-claim.component';
import { ClaimsDocumentUploadComponent } from '../claims-document-upload/claims-document-upload.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { environment } from '../../environments/environment';

@NgModule({
  declarations: [
    ClaimCustomerComponent,
    ClaimPicturesComponent,
    ClaimRepairFacilityComponent,
    ReportAClaimComponent,
    ClaimsDocumentUploadComponent    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatRadioModule,
    MatChipsModule,
    MatCardModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    RecaptchaV3Module,
    NgxMaskModule.forRoot(),
  ],
  exports:
    [
      ClaimRepairFacilityComponent,
    ],
  providers: [
    { provide: 'CLAIM_SERVICE', useValue: ClaimService },
    { provide: 'USER_CACHE', useValue: UserCache },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaSiteKey },
  ]
})
export class ClaimModule { }
